import { type Configuration } from "../graphql.js";

export const getDefaultBrowserTitle = (config: Configuration, withCompanyName = false): string => {
  const applicationName: string = config?.application?.name || "Selector";
  return `${withCompanyName ? "Genedata " : ""}${applicationName}`;
};
